

































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AvailabilitySearchResults from "./AvailabilitySearchResults.vue";
import AvailabilitySearchResultsMobile from "./AvailabilitySearchResultsMobile.vue";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import {
  AvailabilitySearchResult,
  SelectedAvailability,
} from "@/shared/models/availability";
import { AvailabilitySearchPrefillModel } from "./types";
import { SearchRestrictionsModel } from "../reservation-form/types";
import AvailabilitySearchForm, {
  AvailabilitySearchFormModel,
} from "./components/AvailabilitySearchForm.vue";
import * as _ from "lodash";

@Component({
  components: {
    AvailabilitySearchResults,
    AvailabilitySearchResultsMobile,
    AvailabilitySearchForm,
  },
})
export default class AvailabilitySearch extends Vue {
  open = true;
  @Getter("language/language") language?: string;

  searchFormModel: AvailabilitySearchFormModel = {
    period: [],
    numberOfUnits: 1,
    numberOfAdults: 2,
    numberOfChildren: 0,
    numberOfBedrooms: 0,
    numberOfBathrooms: 0,
    childAges: [],
    includeSpecialOffers: true,
  };

  @PropSync("openFilter") globalOpenFilter?: boolean;
  @Prop({ default: undefined }) prefill?: AvailabilitySearchPrefillModel;
  @Prop({ default: undefined }) takenAvailabilities?: SelectedAvailability[];
  @Prop({ default: undefined }) freedAvailabilities?: SelectedAvailability[];
  @Prop() confirmSelectionLabel?: string;
  @Prop() isMobile?: boolean;
  @Prop() isOpen?: boolean;

  @Watch("prefill", { immediate: true, deep: true })
  prefillChanged() {
    if (this.prefill && this.searchFormModel) {
      if (this.prefill.period && this.prefill.period.length == 2) {
        this.searchFormModel.period = [];
        this.searchFormModel.period.push(
          this.prefill.period[0].toISOString().substring(0, 10),
          this.prefill.period[1].toISOString().substring(0, 10)
        );
      }

      this.searchFormModel.numberOfUnits = this.prefill.numberOfUnits;
      this.searchFormModel.numberOfAdults = this.prefill.numberOfAdults;
      this.searchFormModel.numberOfChildren = this.prefill.numberOfChildren;
      this.searchFormModel.numberOfBedrooms = this.prefill.numberOfBedrooms;
      this.searchFormModel.numberOfBathrooms = this.prefill.numberOfBathrooms;
      if (this.prefill.childrenAges && this.prefill.childrenAges.length > 0) {
        this.searchFormModel.childAges = _.cloneDeep(this.prefill.childrenAges);
      } else {
        this.setChildAges();
      }
      this.updateRestrictions();
      this.resetResults();
    }
  }

  setChildAges() {
    if (
      !this.searchFormModel.numberOfChildren ||
      this.searchFormModel.numberOfChildren <= 0
    ) {
      this.searchFormModel.childAges = [];
      return;
    }
    while (
      this.searchFormModel.childAges.length <
      this.searchFormModel.numberOfChildren
    ) {
      this.searchFormModel.childAges.push(0);
    }
    while (
      this.searchFormModel.childAges.length >
      this.searchFormModel.numberOfChildren
    ) {
      this.searchFormModel.childAges.pop();
    }
  }

  restrictions: SearchRestrictionsModel | null = null;
  updateRestrictions() {
    const period = [];
    if (this.searchFormModel.period.length === 2) {
      const from = new Date(this.searchFormModel.period[0]);
      const to = new Date(this.searchFormModel.period[1]);
      period.push(from, to);
    }

    this.restrictions = {
      period: period,
      numberOfUnits: this.searchFormModel.numberOfUnits,
      numberOfAdults: this.searchFormModel.numberOfAdults,
      numberOfChildren: this.searchFormModel.numberOfChildren,
      numberOfBedrooms: this.searchFormModel.numberOfBedrooms,
      numberOfBathrooms: this.searchFormModel.numberOfBathrooms,
      childrenAges: this.searchFormModel.childAges,
    } as SearchRestrictionsModel;
  }

  @Watch("restrictions")
  restrictionsChanged() {
    this.$emit("update:restrictions", _.cloneDeep(this.restrictions));
  }

  selectedAvailabilities: SelectedAvailability[] = [];
  @Watch("selectedAvailabilities")
  selectedAvailabilitiesChanged() {
    this.$emit("update:selection", _.cloneDeep(this.selectedAvailabilities));
  }

  items: ListModel<AvailabilitySearchResult> = {
    result: [],
    count: 0,
  };

  options!: DataOptions;
  updateOptions(value: DataOptions) {
    this.options = value;
    this.search();
  }
  loading = false;

  resetResults() {
    this.selectedAvailabilities = [];
    this.items = {
      result: [],
      count: 0,
    };

    this.searched = false;
  }

  resetResultsAndForm() {
    this.searchFormModel = {
      period: [],
      numberOfUnits: 1,
      numberOfAdults: 2,
      numberOfChildren: 0,
      numberOfBedrooms: 0,
      numberOfBathrooms: 0,
      childAges: [],
      propertyTypes: [],
      categories: [],
      amenities: [],
      includeSpecialOffers: true,
    };
    this.prefillChanged();

    this.resetResults();
  }

  resetResultsAndSearch() {
    if (this.options) {
      this.options.page = 1;
    }
    this.resetResults();

    this.search();
  }

  updateFilter(filters: any) {
    this.searchFormModel.propertyName = filters.nameFilter;
    this.searchFormModel.cityId = filters.cityId;

    this.resetResultsAndSearch();
  }

  searched = false;

  search() {
    if (this.searchFormModel.period.length != 2) {
      return;
    }

    if (!this.searchFormModel.numberOfAdults) {
      this.searchFormModel.numberOfAdults = 2;
    }

    const requestModel = {
      arrivalDate: new Date(this.searchFormModel.period[0]),
      departureDate: new Date(this.searchFormModel.period[1]),
      propertyTypeIdsJoined: this.searchFormModel.propertyTypes?.join(","),
      categoryIdsJoined: this.searchFormModel.categories?.join(","),
      amenityIdsJoined: this.searchFormModel.amenities?.join(","),
      ...this.searchFormModel,
    };

    this.updateRestrictions();

    this.open = false;
    this.loading = true;
    this.searched = true;

    Vue.axios
      .get<ListModel<AvailabilitySearchResult>>(
        "AdvancedSearch/FindAvailability",
        {
          params: {
            ...requestModel,
            $top:
              this.options && this.options.itemsPerPage != -1
                ? this.options.itemsPerPage
                : null,
            $skip:
              this.options && this.options.itemsPerPage != -1
                ? (this.options.page - 1) * this.options.itemsPerPage
                : 0,
            $count: true,
          },
        }
      )
      .then((response) => {
        this.items = response.data;

        // parse ratesJSON to rates array
        for (const item of this.items.result) {
          // TODO: (borna, paxlos refactor) sort results maybe?
          item.rates = item.ratesJSON ? JSON.parse(item.ratesJSON) : [];
          for (const rate of item.rates) {
            const selectedAmount = SelectedAvailability.GetCountInArray(
              this.selectedAvailabilities,
              item,
              rate
            );
            item.numberOfAvailableUnits =
              item.numberOfAvailableUnits - selectedAmount;
          }
        }
      })
      .finally(() => {
        this.loading = false;
        this.$emit("update:scrollToTop");
      });
  }

  confirmSelection() {
    this.$emit("confirmSelection", _.cloneDeep(this.selectedAvailabilities));
    this.selectedAvailabilities = [];
  }

  @Watch("isOpen", { immediate: true })
  isOpenChanged(fresh: boolean) {
    if (this.isMobile && fresh) {
      this.resetResultsAndSearch();
    }
  }
}
